<div class="form-inner-box">
    <h4 class="text-capitalize position-relative pt-3">
        Welcome to
        <strong class="text-info">the safari Wellness</strong>
        login to continue
    </h4>
    <p>
        <small class="text-capitalize">
            Explore our wellness plans.
        </small>
    </p>
    <form [formGroup]="loginUser" (ngSubmit)="login()" [autocomplete]="false" novalidate>

        <input type="text" trim="blur" [formControl]="email" placeholder="Email" class="form-control mb-3">

        @if((email?.touched || email?.dirty || submitted ) && !email?.valid && !email?.pending){
        <span class="text-danger error">
            @if(email?.errors.required){
            Email is required
            }

            @if(email?.errors.pattern){
            Please Fill Proper Email
            }
        </span>
        }
        <div class="pwd-box">
            <input [type]="showHidePassword?'text':'password'" [formControl]="password" placeholder="Password"
                class="form-control mb-3">
            <span class="cursor-pointer"><i (click)="passwordShowHide()" class="fa-solid"
                    [ngClass]="showHidePassword?'fa-eye-slash':'fa-eye'"></i></span>
        </div>
        @if((password?.touched || password?.dirty || submitted ) && !password?.valid && !password?.pending){
        <span class="text-danger error">
            @if(password?.errors.required){
            Password is required
            }
            @if(password?.errors.minlength){
            Minimum 6 characters required
            }
            @if(password?.errors.maxlength){
            Maximum 20 characters allowed
            }
        </span>
        }


        <div class="d-flex justify-content-between align-items-center flex-column flex-md-row">
            <a href="" class="link-info link align-self-start" [routerLink]="['/forgot_password']">Forgot Password?</a>
            <button class="btn btn-success mt-3 mt-md-0" type="submit">Sign In</button>
        </div>
        <div class="text-center lined-box">Have Not account yet?
            <a href="" [routerLink]="['/registration']" routerLinkActive="router-link-active" class="link-info link">
                Create Account
            </a>
        </div>
    </form>
</div>